module.exports = __webpack_public_path__ + "static/media/manage_customers.aefb9980.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/manage_customers.svg
// module id = 2708
// module chunks = 0